export enum Role {
  Administrator = 'Administrator',
  Firm = 'Firm',
  Estate = 'Estate',
  Advisor = 'Advisor',
  Investor = 'Investor',
  Banker = 'Banker',
  Owner = 'Owner',
  TeamMember = 'TeamMember',
}

export enum LoginAction {
  ConfirmPasswordReset = 'ConfirmPasswordReset',
  LoginVerification = 'LoginVerification',
  ForceSecurityQuestions = 'ForceSecurityQuestions',
  Home = 'Home',
}
